import { ActionTypes } from "../constants/action-types";

const initialState = {
    agendas: [],
    loading: false,
    error: null,
};

export const FetchAgendas = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_AGENDAS_SUCCESS:
      return {
        ...state,
        agendas: action.payload,
        loading: false,
      };
      case "FETCH_AGENDAS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default FetchAgendas;
